import { useTranslation } from '../contexts/I18nContext'

export default useTranslation
